'use client'

import { GoogleOAuthProvider } from '@react-oauth/google'
import { TooltipProvider } from '@real-code-query/ui/Tooltip'
import { ErrorBoundary, Provider } from '@rollbar/react'
import { Session } from 'next-auth'
import { IntercomProvider } from 'react-use-intercom'

import { ApolloProvider } from '@/app/provider/Apollo'
import { AuthProvider } from '@/app/provider/Auth'
import { GlobalDialogsProvider } from '@/app/provider/GlobalDialogsProvider'
import { PendoProvider } from '@/app/provider/Pendo'
import { PostHogProvider } from '@/app/provider/Posthog'
import { rollbarConfig } from '@/lib/rollbar'

// MSW is not properly supported for TurboPack (or NextJS v14+ in general)
if (!process.env.NEXT_PUBLIC_TURBO_ENABLED && process.env.NODE_ENV === 'development') {
  import('@/__dev__/mocks').then(({ initMocks }) => {
    initMocks()
  })
}

interface IProviders {
  children: React.ReactNode
  token: Session['token']
}

export const Providers = ({ children, token }: IProviders) => {
  return (
    <GoogleOAuthProvider
      clientId={
        process.env.GOOGLE_DRIVE_CLIENT_ID ||
        '996936391552-48m5evvm2obhvmf5f6bala937jrtaaht.apps.googleusercontent.com'
      }
    >
      <Provider config={rollbarConfig}>
        <ErrorBoundary>
          <AuthProvider>
            <PostHogProvider>
              <TooltipProvider delayDuration={400}>
                <ApolloProvider token={token}>
                  <PendoProvider>
                    <IntercomProvider appId={'hpm93nc9'} autoBoot>
                      <GlobalDialogsProvider>{children}</GlobalDialogsProvider>
                    </IntercomProvider>
                  </PendoProvider>
                </ApolloProvider>
              </TooltipProvider>
            </PostHogProvider>
          </AuthProvider>
        </ErrorBoundary>
      </Provider>
    </GoogleOAuthProvider>
  )
}
